import { updateSlideInDeck } from "../editor/deckEditor.js";
import { surfBedrockChat } from "./surfBedrockChat.js";
import { SURF_CONTENT_POLISH_SYSTEM, applyPolishToOutlineSections, applyPolishToSlide, extractPolishPayloadFromOutlineSection, extractPolishPayloadFromSlide, parsePolishedOutlineResponse, parsePolishedSlideResponse, polishOutlineUserPrompt, polishSlideUserPrompt, } from "./contentPolishPrompt.js";
export { applyPolishToOutlineSections, applyPolishToSlide, extractPolishPayloadFromSlide, extractPolishPayloadFromOutlineSection, parsePolishedSlideResponse, parsePolishedOutlineResponse, } from "./contentPolishPrompt.js";
export async function polishSlideCopy(cfg, slide) {
    const payload = extractPolishPayloadFromSlide(slide);
    const raw = await surfBedrockChat(cfg, {
        feature: "surf.content.polish",
        systemText: SURF_CONTENT_POLISH_SYSTEM,
        userText: polishSlideUserPrompt(payload),
        maxTokens: 4096,
    });
    return parsePolishedSlideResponse(raw);
}
export async function polishDeckSlide(cfg, deck, slideIndex) {
    const slide = deck.slides[slideIndex];
    if (!slide)
        throw new Error("Slide non trovata.");
    const polished = await polishSlideCopy(cfg, slide);
    return updateSlideInDeck(deck, slide.id, (s) => applyPolishToSlide(s, polished));
}
export async function polishAllDeckSlides(cfg, deck, onSlide) {
    let next = deck;
    const total = deck.slides.length;
    for (let i = 0; i < total; i += 1) {
        onSlide?.(i, total);
        next = await polishDeckSlide(cfg, next, i);
    }
    return next;
}
export async function polishOutlineSections(cfg, sections) {
    if (!sections.length)
        return sections;
    const payload = sections.map(extractPolishPayloadFromOutlineSection);
    const raw = await surfBedrockChat(cfg, {
        feature: "surf.content.polish",
        systemText: SURF_CONTENT_POLISH_SYSTEM,
        userText: polishOutlineUserPrompt(payload),
        maxTokens: 8192,
    });
    const polished = parsePolishedOutlineResponse(raw, sections.map((s) => s.id));
    return applyPolishToOutlineSections(sections, polished);
}
